// @ts-strict-ignore
import {AfterViewInit, Component, effect, inject, input, OnInit} from "@angular/core";
import {ChecklistItem, OperatorChecklist} from "@models";
import {SimChecklistService, TrackByMethods} from "@services";
import {ChecklistContextService} from "../services/checklist-context.service";
import {ChecklistAnswerService} from "../services/checklist-answer.service";
import {configureChecklistProviders} from "../services/assessable.configuration";
import {AssessableUiService} from "../services/assessable-ui.service";
import {AssessablePanelMode, AssessablePanelType} from "@common/components/assessment/utils";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
	selector: "sim-operator-checklist-panel",
	templateUrl: "./operator-checklist-panel.component.html",
	styleUrls: ["./operator-checklist-panel.component.scss"],
	providers: [...configureChecklistProviders()],
	standalone: false,
})
export class OperatorChecklistPanelComponent implements OnInit, AfterViewInit {
	// Enums
	protected readonly TrackByMethods = TrackByMethods;
	protected readonly AssessablePanelType = AssessablePanelType;

	// I/O
	public assessable = input.required<OperatorChecklist>();
	public mode = input.required<AssessablePanelMode>();
	public isInArchive = input(false);

	// Effects
	private _initContextEffect = effect(() => this._initContext(this.assessable()), {allowSignalWrites: true});
	private _changeModeEffect = effect(() => this.store.setMode(this.mode()), {allowSignalWrites: true});

	// Injections
	protected store: AssessableUiService<ChecklistItem> = inject(AssessableUiService);
	private _answerService = inject(ChecklistAnswerService);
	private _checklistService = inject(SimChecklistService);
	private _contextService = inject(ChecklistContextService);

	public ngOnInit() {
		this._initContext(this.assessable());
		this._answerService.$savingPipeline.pipe(untilDestroyed(this)).subscribe();
	}

	private _initContext(assessable: OperatorChecklist) {
		this._contextService.initialize(assessable);
		this._answerService.initialize(assessable, (data) => {
			this._checklistService
				.updateAnswerOfOperatorChecklist({
					answer: data.answer,
					checklistId: data.checklistId,
					checklistItemId: data.checklistItemId,
				})
				.then();
		});
	}

	public ngAfterViewInit() {
		this.store.expandFirstGroupAndItem();
	}
}
